
  import React from "react"
  import Component from "/Users/dale/Documents/cp-website/src/layouts/index.js"
  import data from "/Users/dale/Documents/cp-website/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js